import _ from 'lodash';
import { Epic, ofType } from 'redux-observable';
import { merge } from 'rxjs';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { ROUTER_ACTION_NAMES } from '../../../router/router.actions';
import { getOrganizationNameById } from '../../../selectors/organizations/organizations';
import { PROJECTS_ACTION_NAMES } from '../../actions/project';
import { GOOGLE_ANALYTICS_ACTION_NAMES } from '../../middlewares/google-analytics/google-analytics';
import { getProjectNameById } from '../../projects/projects.selectors';
import { Action } from '../../redux.types';

const organizationIdExists = (action) =>
  _.has(action, 'payload.context.params.organizationId');
const projectIdExists = (action) =>
  _.has(action, 'payload.context.params.projectId');

const getOrganizationId = (payload) =>
  _.get(payload, 'context.params.organizationId');
const getProjectId = (payload) => _.get(payload, 'context.params.projectId');
const getRouterPath = (payload) => _.get(payload, 'context.path');

export const googleAnalyticsEpic: Epic<Action, any> = (action$, state$) => {
  const routerShow$ = action$.pipe(ofType(ROUTER_ACTION_NAMES.SHOW));
  const projectsLoaded$ = action$.pipe(
    ofType(PROJECTS_ACTION_NAMES.PROJECTS_SUCCESS),
  );

  const routerShowWithoutOrganization$ = routerShow$.pipe(
    filter(_.negate(organizationIdExists)),
    map(({ payload }) => ({
      type: GOOGLE_ANALYTICS_ACTION_NAMES.SEND_EVENT,
      payload: {
        path: getRouterPath(payload),
      },
    })),
  );

  const routerShowWithOrganization$ = routerShow$.pipe(
    filter(organizationIdExists),
    filter(_.negate(projectIdExists)),
    map(({ payload }) => {
      const state = state$.value;

      const organizationId = getOrganizationId(payload);
      const organizationName = getOrganizationNameById(state)(organizationId);
      const path = getRouterPath(payload);

      return {
        type: GOOGLE_ANALYTICS_ACTION_NAMES.SEND_EVENT,
        payload: {
          organizationId,
          organizationName,
          path,
        },
      };
    }),
  );

  const waitForProjectsLoaded$ = projectsLoaded$.pipe(
    withLatestFrom(routerShow$.pipe(filter(organizationIdExists))),
    withLatestFrom(routerShow$.pipe(filter(projectIdExists))),
    map(([projectsSuccessAction, { payload }]) => {
      const state = state$.value;

      const organizationId = getOrganizationId(payload);
      const organizationName = getOrganizationNameById(state)(organizationId);
      const path = getRouterPath(payload);
      const projectId = getProjectId(payload);
      const projectName = getProjectNameById(state)(projectId);

      return {
        type: GOOGLE_ANALYTICS_ACTION_NAMES.SEND_EVENT,
        payload: {
          organizationId,
          organizationName,
          path,
          projectId,
          projectName,
        },
      };
    }),
  );

  return merge(
    routerShowWithoutOrganization$,
    routerShowWithOrganization$,
    waitForProjectsLoaded$,
  );
};
